import { MailTemplate } from '@/interfaces/mailTemplate';
import { EntityResource } from './entity.resource';

export class MailTemplateResource extends EntityResource<MailTemplate> {
  protected getFields = {
    id: true,
    name: true,
    subject: true,
    fromName: true,
    fromAddress: true,
    to: true,
    body: true
  };

  protected listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({ entityName: 'mailTemplate' });
  }
}

export const mailTemplateResource = new MailTemplateResource();
